import { useState } from "react";
import { Plus, Minus } from "lucide-react";

export const FAQ_ITEMS = [
  {
    q: "Is this hourly parking?",
    a: "No. NightBay is monthly, overnight parking — one bay, one renter, minimum one month.",
  },
  {
    q: "Is my car insured while parked?",
    a: "No. NightBay is not an insurer and doesn't hold your keys. Treat it like parking at a friend's building — the host gives you space, not custody.",
  },
  {
    q: "Can I list my apartment bay if I'm just a resident?",
    a: "Usually yes, if the bay is allotted to you and your society's bye-laws allow it. Check with your committee first. If they'd rather do it officially, we can list the society's spare bays instead — free above 11 bays.",
  },
  {
    q: "How do I know the bay is real?",
    a: "We call the host, match the photos to the address, and for sites of 5+ bays we physically visit before publishing. Bays that fail the check never appear.",
  },
  {
    q: "What if the bay isn't what the photos showed?",
    a: "Report it within 48 hours of first use and you get a full refund. If a host doesn't honour a live booking, you get a pro-rated refund for the unused days.",
  },
  {
    q: "When do I get the host's phone number?",
    a: "As soon as the host accepts your request. Before that, the host can see your name, number and verification status so they can call and vet you.",
  },
  {
    q: "How do hosts get paid?",
    a: "Into the bank account linked to their PAN, monthly, through an Indian payment gateway. Hosts keep their full asking price.",
  },
  {
    q: "How do I leave?",
    a: "Give 15 days' notice from either side, from the app or by calling us. You pay for the month you're in, nothing after it.",
  },
];

export const FAQ = () => {
  const [open, setOpen] = useState(0);
  return (
    <section data-testid="faq" className="nb-section bg-surface2">
      <div className="nb-shell max-w-[820px]">
        <p className="nb-eyebrow">FAQ</p>
        <h2 className="nb-h2 mt-4">Questions people actually ask</h2>

        <div className="mt-10 divide-y divide-line border-y border-line">
          {FAQ_ITEMS.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={item.q}>
                <h3>
                  <button
                    type="button"
                    data-testid={`faq-q-${i}`}
                    aria-expanded={isOpen}
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="flex w-full items-center justify-between gap-4 py-5 text-left font-head text-base uppercase tracking-[0.4px] text-ink transition-colors hover:text-brand"
                  >
                    {item.q}
                    {isOpen ? (
                      <Minus size={18} className="shrink-0 text-brand" aria-hidden="true" />
                    ) : (
                      <Plus size={18} className="shrink-0 text-ink3" aria-hidden="true" />
                    )}
                  </button>
                </h3>
                {isOpen && (
                  <p data-testid={`faq-a-${i}`} className="pb-5 text-sm text-ink2">
                    {item.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
